export default "__VITE_ASSET__Bp6IFBgY__"